import React from "react";
import NavBar from "../components/NavBar";
import HeroImage2 from "../components/HeroImage2";
import ProjectCard from "../components/Project";
import PricingCard from "../components/PricingCard";
import Footer from "../components/Footer";

const Project = () => {
  return (
    <div>
      <NavBar />
      {/* <HeroImage2
        bgImage="hero-img-project"
        heading="PROJECTS"
        text="Design and Developed Web and System Applications"
      /> */}
      <ProjectCard />
      {/*<PricingCard />*/}
      {/* <Footer /> */}
    </div>
  );
};

export default Project;
